import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        webConActivitys: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        webConActivityMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getWebConActivitysRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWebConActivitys", null);
            } else {
                dispatch("receivingWebConActivitys"); // สถานะ กำลังบันทึก


                // axios.get('/web_con_activitys').then(res => {
                //
                //     dispatch("receiveWebConActivitys", res.data);
                // })


                // const formData = new FormData();
                // formData.append('activity_type', payload.activity_type);
                // formData.append('activity_type_detail', payload.activity_type_detail);
                // formData.append('status_check', payload.status_check);
                // formData.append('user_name', payload.user_name);

                axios.get('/web_con_activitys', {params: payload})
                    .then(function (res) {
                        dispatch("receiveWebConActivitys", res.data);
                    })
                    .catch(function (e) {
                        console.log(e);
                        dispatch("receiveWebConActivitys", null);
                    });

            }
        },
        loadWebConActivityRequest({dispatch}, id) {
            // We check if app runs with backend mode


            if (!config.isBackend) {
                dispatch("receiveWebConActivity", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingWebConActivity");
                axios.get('/web_con_activitys/' + id).then(res => {
                    dispatch("receiveWebConActivity", res.data);
                })
            }
        },
        updateWebConActivityRequest({dispatch}, payload) {


            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingWebConActivity");
            const formData = new FormData();
            formData.append('file_fi', payload.avatarFileFi);
            formData.append('activity_id', payload.activity_id);
            formData.append('activity_type', payload.activity_type);
            formData.append('activity_level', payload.activity_level);
            formData.append('activity_title_th', payload.activity_title_th);
            formData.append('activity_title_en', payload.activity_title_en);
            formData.append('activity_agency_title', payload.activity_agency_title);
            formData.append('activity_place_title', payload.activity_place_title);
            formData.append('activity_date', payload.activity_date);
            formData.append('status_link', payload.status_link);
            formData.append('activity_h_file', payload.activity_h_file);
            formData.append('activity_h_url', payload.activity_h_url);
            formData.append('status_check', payload.status_check);
            formData.append('green_office', payload.green_office);
            formData.append('active', payload.active);
            formData.append('remark', payload.remark);
            formData.append('checkbox_select', payload.checkbox_select);
            axios.post('/update_con_activitys', formData).then(res => {
                dispatch("updateWebConActivity", res.data);
            })

        },
        createWebConActivityRequest({dispatch}, payload) {

            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingWebConActivity");

            const formData = new FormData();
            formData.append('file_fi', payload.avatarFileFi);
            formData.append('activity_type', payload.activity_type);
            formData.append('activity_level', payload.activity_level);
            formData.append('activity_title_th', payload.activity_title_th);
            formData.append('activity_title_en', payload.activity_title_en);
            formData.append('activity_agency_title', payload.activity_agency_title);
            formData.append('activity_place_title', payload.activity_place_title);
            formData.append('activity_date', payload.activity_date);
            formData.append('status_link', payload.status_link);
            formData.append('activity_h_file', payload.activity_h_file);
            formData.append('activity_h_url', payload.activity_h_url);
            formData.append('status_check', payload.status_check);
            formData.append('green_office', payload.green_office);
            formData.append('active', payload.active);
            formData.append('remark', payload.remark);
            formData.append('checkbox_select', payload.checkbox_select);
            axios.post('/web_con_activitys', formData).then(res => {
                dispatch("receiveWebConActivity", res.data);

            })


        },
        deleteWebConActivityRequest({dispatch}, payload) {

            dispatch("afterDeleteWebConActivity", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingWebConActivity", payload);

            axios.post('/delete_con_activitys', payload).then(res => {
                dispatch("deleteWebConActivity", {activity_id: payload.activity_id, res: res});
            })


        },
        receiveWebConActivitys({commit}, payload) {
            commit("RECEIVED_CONACTIVITYS", payload)
        },
        receivingWebConActivitys({commit}) {
            commit("RECEIVING_CONACTIVITYS") //call matutions --> state.isReceiving = true;
        },
        receiveWebConActivity({commit}, payload) {
            commit("RECEIVED_CONACTIVITY", payload)
        },
        receivingWebConActivity({commit}) {
            commit("RECEIVING_CONACTIVITYS") //call matutions --> state.isReceiving = true;
        },
        updateWebConActivity({commit}, payload) {
            commit("UPDATED_CONACTIVITY", payload)
        },
        updatingWebConActivity({commit}) {
            commit("UPDATING_CONACTIVITY") //  call matutions --> state.isUpdating = true;
        },
        deleteWebConActivity({commit}, payload) {
            commit("DELETED_CONACTIVITY", payload)
        },
        deletingWebConActivity({commit}, payload) {
            commit("DELETING_CONACTIVITY", payload)
        },
        afterDeleteWebConActivity({commit}, payload) {
            commit("AFFTER_DELETED_CONACTIVITY", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_CONACTIVITYS(state, payload) {

            state.webConActivitys = payload;
            state.isReceiving = false;

        },
        RECEIVING_CONACTIVITYS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_CONACTIVITY(state, payload) {


            if (payload.activity_id == undefined) {
                let error = payload.e.errorInfo == undefined ? payload.message : payload.e.errorInfo.toString()
                let webConActivityMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    webConActivityMessage: (state.webConActivityMessage == webConActivityMessage ? webConActivityMessage + ' ' : webConActivityMessage),

                });
            } else {
                let webConActivityMessage = 'บันทึกสำเร็จ! รายการ ' + payload.activity_id + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    webConActivitys: [...state.webConActivitys, payload],
                    isReceiving: false,
                    errorMessage: false,
                    webConActivityMessage: (state.webConActivityMessage == webConActivityMessage ? webConActivityMessage + ' ' : webConActivityMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },

        UPDATED_CONACTIVITY(state, payload) {

            let index = state.webConActivitys.findIndex(p => p.activity_id === payload.activity_id);
            let webConActivityMessage = 'บันทึกสำเร็จ! รายการ ' + payload.activity_id + ' ถูกแก้ไขแล้ว';
            state = Object.assign(state, {
                webConActivitys: state.webConActivitys.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                webConActivityMessage: (state.webConActivityMessage == webConActivityMessage ? webConActivityMessage + ' ' : webConActivityMessage),
            })
        },
        UPDATING_CONACTIVITY(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_CONACTIVITY(state, payload) {


            if (payload.activity_id == undefined || payload.res.data.message == 'Relation') {
                let webConActivityMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.activity_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    webConActivityMessage: (state.webConActivityMessage == webConActivityMessage ? webConActivityMessage + ' ' : webConActivityMessage),

                });
            } else {
                let indexToDelete = state.webConActivitys.findIndex(p => p.activity_id === payload.activity_id);
                let webConActivitys = [...state.webConActivitys];
                webConActivitys.splice(indexToDelete, 1);
                let webConActivityMessage = 'บันทึกสำเร็จ! รายการ ' + payload.activity_id + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    webConActivitys: [...webConActivitys],
                    isDeleting: false,
                    idToDelete: null,
                    webConActivityMessage: (state.webConActivityMessage == webConActivityMessage ? webConActivityMessage + ' ' : webConActivityMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_CONACTIVITY(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.activity_id;
        },
        AFFTER_DELETED_CONACTIVITY(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
